import React from 'react';
import EventComparisonChart from '../../Seasonal/EventComparisonChart';

/**
 * Seasonal performance widget renderer.
 *
 * Wraps EventComparisonChart so the widget grid can host year-over-year
 * comparisons for a configured seasonal event.
 *
 * widget.config:
 *   - event_key  (default 'eid_al_fitr')
 *   - metric     (default 'totalSales' — passed through to compare endpoint)
 *   - property_id (optional)
 */
export default function SeasonalWidget({ data, widgetId, widget }) {
    const cfg = widget?.config || data?.config || {};
    const eventKey = cfg.event_key || 'eid_al_fitr';
    const metric = cfg.metric || 'totalSales';
    const propertyId = cfg.property_id;

    return (
        <div style={{ height: '100%', padding: '4px 10px 8px' }}>
            <EventComparisonChart
                eventKey={eventKey}
                metric={metric}
                propertyId={propertyId}
            />
        </div>
    );
}
